import { Component, ChangeDetectorRef, OnInit, ViewEncapsulation } from '@angular/core';
import { AgentStatIndicator } from './models/agent-stat.model';
import { slideInDetailedStatsAnimation, slideInStatsAnimation } from './animation/slide-in-animation';
import { AgentStatsService } from './services/agent-stats.service';
import { AgentStatStates } from './agent-stat-enums';
import { BcAnalytics } from 'common/analytics/analytics.service';
import { AgentStatsHelper } from './agent-stat-helper';
import { CommonAuthService } from 'common/auth/common-auth.service';

const MAX_NUM_OF_TOP_INDICATORS = 3;

@Component({
  selector: 'app-agent-stats',
  templateUrl: './agent-stats.component.html',
  styleUrls: ['./agent-stats.component.scss'],
  animations: [slideInStatsAnimation, slideInDetailedStatsAnimation],
  encapsulation: ViewEncapsulation.None
})

export class AgentStatsComponent implements OnInit {
  public state = AgentStatStates.MINIMIZED;
  public detailedAgentStatIndicators: AgentStatIndicator[];
  public compactAgentStatIndicators: AgentStatIndicator[] = [];
  public isExpanded: boolean = false;
  public shouldUseMaxHeight: boolean = false;
  public isHybrid = this._commonAuth.isHybrid();

  constructor(private _changeDetector: ChangeDetectorRef,
              private _agentStatsService: AgentStatsService,
              private _bcAnalytics: BcAnalytics,
              private _commonAuth: CommonAuthService) {
  }

  async ngOnInit() {
    this._agentStatsService.getStatSettings().then((resp) => {
      this.detailedAgentStatIndicators = resp;
      this._collectCompactAgentStatIndicators();
      this._changeDetector.detectChanges();
      this._sendAnalytics(this.detailedAgentStatIndicators);
    });
  }

  public toggleDetailedStats(): void {
    this.isExpanded = !this.isExpanded;
    this._bcAnalytics.eventTrack(this.isExpanded ? 'OpenAgentStat' : 'CloseAgentStat');
  }

  public animationStart(event) {
    if (event.fromState === AgentStatStates.MINIMIZED && event.toState === AgentStatStates.EXPANDED) {
      this.shouldUseMaxHeight = true;
    }
    if (event.fromState === AgentStatStates.EXPANDED && event.toState === AgentStatStates.MINIMIZED) {
      this.shouldUseMaxHeight = false;
    }
  }

  public animationEnd(event) {
    if (event.fromState === AgentStatStates.MINIMIZED && event.toState === AgentStatStates.EXPANDED) {
      this.shouldUseMaxHeight = true;
    }
    if (event.fromState === AgentStatStates.EXPANDED && event.toState === AgentStatStates.MINIMIZED) {
      this.shouldUseMaxHeight = false;
    }
  }

  private _collectCompactAgentStatIndicators(): void {
    for (let idx = 0; idx < MAX_NUM_OF_TOP_INDICATORS; idx++) {
      if (this.detailedAgentStatIndicators[idx]) {
        this.compactAgentStatIndicators.push(this.detailedAgentStatIndicators[idx]);
      }
    }
  }

  private _sendAnalytics(indicatorList): void {
    let convertedIndicatorList = [];
    indicatorList.forEach((ind) => {
      convertedIndicatorList.push(AgentStatsHelper.convertIndicator(ind));
    });
    this._bcAnalytics.eventTrack('AgentStatsLoaded', { agentStatsList: convertedIndicatorList });
  }
}
